export const checkProperties = (data, property, types) => {
  if (!data) {
    return false;
  }

  const filteredDataByTypes =
    types.length > 0 ? data.filter(item => types.includes(item.type)) : data;

  if (property === 'paymentEcOnly') {
    return (
      filteredDataByTypes.filter(
        (item: any) =>
          item.paymentMethods.some(({type, changeable}) => type === 'EC' && changeable) === true,
      ).length === 0
    );
  }

  return filteredDataByTypes.filter(item => item[property] === true).length === 0;
};
